'use client';

import React, { Suspense } from 'react';
import { useUI } from '@contexts/ui.context';
import { Drawer } from '@components/common/drawer/drawer';
import { getDirection } from '@utils/get-direction';
import motionProps from '@components/common/drawer/motion';
const Cart = React.lazy(() => import('@components/cart/cart'));
const OrderDetails = React.lazy(() => import('@components/order/order-drawer'));

export default function ManagedDrawer({ lang }: { lang: string }) {
  const { displayDrawer, closeDrawer, drawerView } = useUI();
  const dir = getDirection(lang);
  const contentWrapperCSS = dir === 'ltr' ? { right: 0 } : { left: 0 };

  return (
    <Drawer
      rootClassName={
        drawerView === 'ORDER_DETAILS' ? 'order-details-drawer' : ''
      }
      open={displayDrawer}
      placement={dir === 'rtl' ? 'left' : 'right'}
      onClose={closeDrawer}
      // @ts-ignore
      level={null}
      contentWrapperStyle={contentWrapperCSS}
      {...motionProps}
    >
      <Suspense
        fallback={
          <div className="flex items-center justify-center p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand"></div>
          </div>
        }
      >
        {drawerView === 'CART_SIDEBAR' && <Cart lang={lang} />}
        {drawerView === 'ORDER_DETAILS' && <OrderDetails lang={lang} />}
      </Suspense>
    </Drawer>
  );
}
